
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.512 30.05c3.242 0 6.27-1.054 8.73-2.812l9.258 9.258c.43.43.996.645 1.582.645 1.27 0 2.188-.977 2.188-2.227 0-.586-.196-1.133-.626-1.562l-9.199-9.22a14.96 14.96 0 003.086-9.1c0-8.262-6.758-15.02-15.02-15.02C7.232.012.493 6.77.493 15.032c0 8.261 6.738 15.019 15.02 15.019zm0-3.241c-6.465 0-11.778-5.332-11.778-11.778 0-6.445 5.313-11.777 11.778-11.777 6.445 0 11.777 5.332 11.777 11.777 0 6.446-5.332 11.778-11.777 11.778zm1.582-5.997v-4.316h3.945c.8 0 1.484-.683 1.484-1.465 0-.781-.683-1.465-1.484-1.465h-3.945V9.25c0-.938-.762-1.504-1.582-1.504-.82 0-1.602.566-1.602 1.504v4.316H9.965c-.8 0-1.465.684-1.465 1.465s.664 1.465 1.465 1.465h3.945v4.317c0 .937.781 1.503 1.602 1.503.82 0 1.582-.566 1.582-1.503z","fill":"#fff"}})])
          )
        }
      }
    